import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import useAuthStore from './store/authStore';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Expired from './pages/Expired';
import Platform from './pages/Platform';
import Layout from './components/layout/Layout';
import SetupGate from './components/setup/SetupGate';
const ProtectedRoute = ({ children }) => {
  const token = useAuthStore((state) => state.token);
  return token ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/expired" element={<Expired />} />
        <Route path="/platform" element={<Platform />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <SetupGate>
                <Layout />
              </SetupGate>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;